export default __webpack_public_path__ + "static/media/flight.08a898bf.mp4";